export default "__VITE_ASSET__CgD3TicQ__"